<template>
    <component :is="'div'">
        <slot :briefs="briefs" :close="close" />
    </component>
</template>

<script>
    import useActivationBriefs from '../../../src/composables/use-activation-briefs';

    export default {
        name: 'ActivationTasksSummaryProvider',

        computed: {
            briefs() {
                return useActivationBriefs().getActivationBriefsForTaskSummary(this.$root.briefs);
            }
        },

        methods: {
            close() {
                this.$router.push({ name: 'sponsorships' });
            }
        }
    };
</script>
